// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3MDPp","row":"ProcedureTreatmentSummary_row__211xc"};